function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 80,
  r: 80,
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 133.025V52C20 45.3726 25.3726 40 32 40H128C134.627 40 140 45.3726 140 52V128.087C125.738 147.489 103.286 160 78.0328 160C54.9923 160 34.2841 149.586 20 133.025Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M54.0284 68.0501L60.9541 61.0501C62.253 59.7374 64.0146 59 65.8515 59L80.2971 59V55.5C80.2971 54.5717 80.6619 53.6815 81.3113 53.0251C81.9607 52.3687 82.8415 52 83.7599 52C84.6783 52 85.5591 52.3687 86.2085 53.0251C86.858 53.6815 87.2228 54.5717 87.2228 55.5V59L101.074 59C102.911 59 104.673 59.7375 105.971 61.0503C107.27 62.363 108 64.1435 108 66V80C108 81.8565 107.27 83.637 105.971 84.9497C104.673 86.2625 102.911 87 101.074 87H87.2228L87.2228 104.5C87.2228 105.428 86.858 106.319 86.2085 106.975C85.5591 107.631 84.6783 108 83.7599 108C82.8415 108 81.9607 107.631 81.3113 106.975C80.6619 106.319 80.2971 105.428 80.2971 104.5L80.2971 87H65.8515C64.9419 87 64.0413 86.819 63.201 86.4672C62.3607 86.1154 61.5972 85.5997 60.9541 84.9496L54.0284 77.9496C52.7296 76.6368 52 74.8564 52 72.9999C52 71.1434 52.7296 69.3629 54.0284 68.0501ZM56.4772 75.4748L63.4029 82.4748C63.7237 82.8009 64.1053 83.0594 64.5256 83.2354C64.9459 83.4114 65.3965 83.5013 65.8515 83.5L101.074 83.5C101.992 83.4989 102.873 83.1298 103.522 82.4737C104.171 81.8176 104.536 80.9279 104.537 80V66C104.536 65.0721 104.171 64.1825 103.522 63.5263C102.873 62.8702 101.992 62.5011 101.074 62.5L65.8515 62.5C65.3965 62.4987 64.9459 62.5886 64.5256 62.7646C64.1053 62.9406 63.7237 63.1991 63.4029 63.5252L56.4772 70.525C55.8287 71.1819 55.4646 72.072 55.4646 72.9999C55.4646 73.9278 55.8287 74.8179 56.4772 75.4748Z",
  fill: "#6CB52D",
  fillOpacity: 0.4
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 80,
  y1: 0,
  x2: 80,
  y2: 160,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F1F4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CBD7EB",
  stopOpacity: 0
})));

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.76b4cda8.svg";
export { ForwardRef as ReactComponent };